@if (httpLoadingService.isLoading$| async) {
    <p-progressBar mode="indeterminate" id="loadingIndicator" [style]="{ height: '6px' }"/>
}

<div class="layout-wrapper">
    <div class="layout-topbar" [ngClass]="{'layout-topbar-sticky': topbarIsSticky}">
        <div class="layout-topbar-inner">
            <div class="layout-topbar-logo-container">
                <a href="/" class="layout-topbar-logo">
                    @if (darkMode) {
                        <img src="images/cpe_logo_neg.svg" alt="Logo BayWa r.e." height="40">
                    } @else {
                        <img src="images/cpe_logo.png" alt="Logo BayWa r.e." height="40">
                    }
                </a>

            </div>

            <ul class="topbar-items">
                <li>
                    <button pButton (click)="toggleDarkMode()" class="topbar-item">
                        @if (darkMode) {
                            <icon icon="sun"></icon>
                        } @else {
                            <icon icon="moon"></icon>
                        }
                    </button>
                </li>
                @if (isAuthenticated && auth.can((Permission.ADMIN))) {
                    <li>
                        <button pButton (click)="logout()" class="topbar-item">
                            <icon icon="logout"></icon>
                        </button>
                    </li>
                } @else {
                    <li>
                        <button (click)="login()" class="topbar-item">
                            <div class="menu-icon">
                                <icon icon="login" pStyleClass="layout-menuitem-icon"></icon>
                            </div>
                        </button>
                    </li>
                }

                <li class="menu-button">
                    <button class="flex flex-shrink-0 px-link border-1 border-solid w-2rem h-2rem surface-border border-round surface-card align-items-center justify-content-center transition-all transition-duration-300 hover:border-primary menu-button"
                            (click)="extendSidebar = !extendSidebar">
                        <icon icon="menu"></icon>
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div class="layout-mask {{extendSidebar?'layout-mask-active':''}}"></div>

    <div class="layout-content">
        <div class="layout-sidebar {{extendSidebar?'active':''}}">
            <aside>
                <nav>
                    <ol class="layout-menu">
                        @for (r of routes; track r) {
                            @if (auth.canOneOf(r.data?.['permissions'])) {
                                <li menuitem [route]="r" [isRoot]="true"></li>
                            }
                        }
                    </ol>
                </nav>
            </aside>
        </div>

        <div class="layout-content-slot">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<p-toast>
    <ng-template let-message #message>
        <p innerHtml="{{message.detail}}"></p>
    </ng-template>
</p-toast>
